import type {ProStatusConfig} from './types';

export const PRO_ROUTES = {
  list: '/services/promotion-center/pro/list',
  add: '/services/promotion-center/pro/add',
  details: '/services/promotion-center/pro/details/:vendorProId',
  paymentSuccess: '/services/promotion-center/pro/payment/success'
} as const;

export const PRO_ZONE_COLOR_TOKENS: Record<string, `--color-${string}`> = {
  express: '--color-orange',
  own: '--color-green-lime',
  vendor_fleet: '--color-teal',
  timeslot: '--color-pink-salmon'
};

export const PRO_ZONE_DOT_CLASS: Record<string, string> = {
  express: 'bg-orange',
  own: 'bg-green-lime',
  vendor_fleet: 'bg-teal',
  timeslot: 'bg-pink-salmon'
};

export const PRO_ZONE_SLIDER_CLASS: Record<string, string> = {
  express:
    '[&_span]:bg-orange [&_input::-webkit-slider-thumb]:border-orange [&_input::-webkit-slider-thumb]:bg-orange [&_input::-moz-range-thumb]:border-orange [&_input::-moz-range-thumb]:bg-orange',
  own: '[&_span]:bg-green-lime [&_input::-webkit-slider-thumb]:border-green-lime [&_input::-webkit-slider-thumb]:bg-green-lime [&_input::-moz-range-thumb]:border-green-lime [&_input::-moz-range-thumb]:bg-green-lime',
  vendor_fleet:
    '[&_span]:bg-teal [&_input::-webkit-slider-thumb]:border-teal [&_input::-webkit-slider-thumb]:bg-teal [&_input::-moz-range-thumb]:border-teal [&_input::-moz-range-thumb]:bg-teal',
  timeslot:
    '[&_span]:bg-pink-salmon [&_input::-webkit-slider-thumb]:border-pink-salmon [&_input::-webkit-slider-thumb]:bg-pink-salmon [&_input::-moz-range-thumb]:border-pink-salmon [&_input::-moz-range-thumb]:bg-pink-salmon'
};

export const PRO_DELIVERY_METHOD_LABELS: Record<string, string> = {
  express: 'محدوده ارسال اسنپ',
  own: 'محدوده ارسال پیک فروشگاه',
  vendor_fleet: 'محدوده ارسال ناوگان فروشگاه'
};

export const PRO_STATUS_CONFIG: Record<string, ProStatusConfig> = {
  INIT: {label: 'در انتظار اجرا', color: 'info'},
  ACTIVE: {label: 'در حال اجرا', color: 'success'},
  DONE: {label: 'پایان یافته', color: 'default'},
  DELETED: {label: 'حذف شده', color: 'error'}
};

export const PRO_MAP_LEGEND_CLIP_PATH =
  'polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%)';

export const PRO_PAGE_SIZE = 10;
export const OTP_COUNTDOWN_SECONDS = 120;
